import { render } from "./newQuestions.vue?vue&type=template&id=423b08fc"
import script from "./newQuestions.vue?vue&type=script&lang=js"
export * from "./newQuestions.vue?vue&type=script&lang=js"

import "./newQuestions.vue?vue&type=style&index=0&id=423b08fc&lang=scss&scope=true"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/adQuestionsPop/newQuestions.vue'],['render',render],['__file',"newQuestions.vue"]])

export default __exports__